/**
 * Fake data and constants for CR Consolidation Report PDF.
 * Structure: { projectInfo, items: [ { businessUnit, year, chartData, tableData } ] }
 * Each item = one page (same UI: bar chart + table).
 */
import moment from 'moment';

export const FAKE_CONSOLIDATION_DATA = {
  projectInfo: {
    projectId: '08dbb6ca-123d-43a2-21b1-388e3e3f264d',
    companyName: 'NEW COMPANY',
    projectCode: 'UEBWJP',
    projectName: 'NEW COMPANY CHECK SEQUENCE',
    startDate: '2024-01-21T17:00:00Z',
    endDate: '2026-08-20T16:59:59.999Z',
    mappingProjectId: null,
    mappingProjectStartDate: null,
    mappingProjectCode: null,
  },
  overView: null,
  healthScreenings: null,
  questionaires: null,
  consolidatedReports: [
    {
      customFieldQuestion: 'sts test 2',
      groupValue: 'Unspecified',
      participantCount: 104,
      healthScreenings: {
        lastYear: null,
        thisYear: 2024,
        nphsYear: 2024,
        hypertensive: 7.14,
        obese: 0,
        highCholesterol: 0,
        diabetic: 0,
        bloodPressure: {
          nphS_PercentNormal: 66.2,
          nphS_PercentAbnormal: 33.8,
          note: null,
          categories: [
            {
              title: 'Normal',
              cutOffs: '<130/<85',
              total: 13,
              percent: 92.86,
              note: null,
              maleTotal: 4,
              malePercent: 28.57,
              femaleTotal: 9,
              femalePercent: 64.29,
              subTotal: 13,
            },
            {
              title: 'High Normal',
              cutOffs: '130-139/85-89',
              total: 0,
              percent: 0,
              note: null,
              maleTotal: 0,
              malePercent: 0,
              femaleTotal: 0,
              femalePercent: 0,
              subTotal: 0,
            },
            {
              title: 'Grade 1\nHypertension',
              cutOffs: '140-159/90-99',
              total: 0,
              percent: 0,
              note: null,
              maleTotal: 0,
              malePercent: 0,
              femaleTotal: 0,
              femalePercent: 0,
              subTotal: 0,
            },
            {
              title: 'Grade 2\nHypertension',
              cutOffs: '>=160/>=100',
              total: 1,
              percent: 7.14,
              note: null,
              maleTotal: 0,
              malePercent: 0,
              femaleTotal: 1,
              femalePercent: 7.14,
              subTotal: 1,
            },
          ],
          trending: null,
          trendings: null,
          totalOfAllTime: 14,
          totalRepeatParticipant: 0,
          repeatParticipantTrendings: null,
        },
        bmi: {
          nphS_PercentUnderweight: 6.3,
          nphS_PercentLowRisk: 34.8,
          nphS_PercentRisk: 36.1,
          nphS_PercentHighRisk: 22.8,
          categories: [
            {
              title: 'Underweight',
              cutOffs: '<18.5',
              total: 4,
              percent: 50,
              note: null,
              maleTotal: 1,
              malePercent: 12.5,
              femaleTotal: 3,
              femalePercent: 37.5,
              subTotal: 4,
            },
            {
              title: 'Low Risk',
              cutOffs: '18.5-22.9',
              total: 3,
              percent: 37.5,
              note: null,
              maleTotal: 1,
              malePercent: 12.5,
              femaleTotal: 2,
              femalePercent: 25,
              subTotal: 3,
            },
            {
              title: 'Moderate Risk',
              cutOffs: '23-27.4',
              total: 1,
              percent: 12.5,
              note: null,
              maleTotal: 1,
              malePercent: 12.5,
              femaleTotal: 0,
              femalePercent: 0,
              subTotal: 1,
            },
            {
              title: 'High Risk',
              cutOffs: '>=27.5',
              total: 0,
              percent: 0,
              note: null,
              maleTotal: 0,
              malePercent: 0,
              femaleTotal: 0,
              femalePercent: 0,
              subTotal: 0,
            },
          ],
          trending: null,
          trendings: null,
          totalOfAllTime: 8,
          totalRepeatParticipant: 0,
          repeatParticipantTrendings: null,
        },
        tc: null,
        randomGlucose: null,
        triglyceride: null,
        ldl: null,
        hdl: null,
        totalThisYear: 80,
      },
    },
    {
      customFieldQuestion: 'sts test 3',
      groupValue: 'Unspecified',
      participantCount: 104,
      healthScreenings: {
        lastYear: null,
        thisYear: 2024,
        nphsYear: 2024,
        hypertensive: 7.14,
        obese: 0,
        highCholesterol: 0,
        diabetic: 0,
        bloodPressure: {
          nphS_PercentNormal: 66.2,
          nphS_PercentAbnormal: 33.8,
          note: null,
          categories: [
            {
              title: 'Normal',
              cutOffs: '<130/<85',
              total: 13,
              percent: 92.86,
              note: null,
              maleTotal: 4,
              malePercent: 28.57,
              femaleTotal: 9,
              femalePercent: 64.29,
              subTotal: 13,
            },
            {
              title: 'High Normal',
              cutOffs: '130-139/85-89',
              total: 0,
              percent: 0,
              note: null,
              maleTotal: 0,
              malePercent: 0,
              femaleTotal: 0,
              femalePercent: 0,
              subTotal: 0,
            },
            {
              title: 'Grade 1\nHypertension',
              cutOffs: '140-159/90-99',
              total: 0,
              percent: 0,
              note: null,
              maleTotal: 0,
              malePercent: 0,
              femaleTotal: 0,
              femalePercent: 0,
              subTotal: 0,
            },
            {
              title: 'Grade 2\nHypertension',
              cutOffs: '>=160/>=100',
              total: 1,
              percent: 7.14,
              note: null,
              maleTotal: 0,
              malePercent: 0,
              femaleTotal: 1,
              femalePercent: 7.14,
              subTotal: 1,
            },
          ],
          trending: null,
          trendings: null,
          totalOfAllTime: 14,
          totalRepeatParticipant: 0,
          repeatParticipantTrendings: null,
        },
        bmi: {
          nphS_PercentUnderweight: 6.3,
          nphS_PercentLowRisk: 34.8,
          nphS_PercentRisk: 36.1,
          nphS_PercentHighRisk: 22.8,
          categories: [
            {
              title: 'Underweight',
              cutOffs: '<18.5',
              total: 4,
              percent: 50,
              note: null,
              maleTotal: 1,
              malePercent: 12.5,
              femaleTotal: 3,
              femalePercent: 37.5,
              subTotal: 4,
            },
            {
              title: 'Low Risk',
              cutOffs: '18.5-22.9',
              total: 3,
              percent: 37.5,
              note: null,
              maleTotal: 1,
              malePercent: 12.5,
              femaleTotal: 2,
              femalePercent: 25,
              subTotal: 3,
            },
            {
              title: 'Moderate Risk',
              cutOffs: '23-27.4',
              total: 1,
              percent: 12.5,
              note: null,
              maleTotal: 1,
              malePercent: 12.5,
              femaleTotal: 0,
              femalePercent: 0,
              subTotal: 1,
            },
            {
              title: 'High Risk',
              cutOffs: '>=27.5',
              total: 0,
              percent: 0,
              note: null,
              maleTotal: 0,
              malePercent: 0,
              femaleTotal: 0,
              femalePercent: 0,
              subTotal: 0,
            },
          ],
          trending: null,
          trendings: null,
          totalOfAllTime: 8,
          totalRepeatParticipant: 0,
          repeatParticipantTrendings: null,
        },
        tc: null,
        randomGlucose: null,
        triglyceride: {
          nphS_PercentOptimal: 0,
          nphS_PercentDesirable: 0,
          nphS_PercentHigh: 0,
          nphS_PercentVeryHigh: 0,
          categories: [
            {
              title: 'string',
              cutOffs: 'string',
              total: 0,
              percent: 0,
              note: 'string',
              maleTotal: 0,
              malePercent: 0,
              femaleTotal: 0,
              femalePercent: 0,
              subTotal: 0,
            },
          ],
          trending: null,
          trendings: null,
        },
        ldl: null,
        hdl: null,
        totalThisYear: 80,
      },
    },
  ],
};

function metricKeyToLabel(metricKey) {
  const map = {
    bloodPressure: 'Blood Pressure',
    bmi: 'Body Mass Index',
    tc: 'Total Cholesterol',
    ldl: 'LDL',
    hdl: 'HDL',
    triglyceride: 'Triglyceride',
    randomGlucose: 'Blood Glucose',
  };
  return map[metricKey] || metricKey;
}

function buildChartDataFromHealthScreenings(healthScreenings) {
  if (!healthScreenings || typeof healthScreenings !== 'object') return [];
  return Object.entries(healthScreenings)
    .filter(([, v]) => Array.isArray(v?.categories) && v.categories.length > 0)
    .map(([metricKey, metric]) => ({
      category: metricKeyToLabel(metricKey),
      items: (metric.categories || []).map((c) => ({
        label: c?.title ?? '',
        femalePct: Number(c?.femalePercent) || 0,
        malePct: Number(c?.malePercent) || 0,
      })),
    }));
}

/** Normalize API response to { projectInfo, items } for consolidation PDF. */
export function normalizeConsolidationData(apiResponse) {
  if (!apiResponse) return { projectInfo: null, items: [] };
  const projectInfo = apiResponse.projectInfo || null;
  const startDate = projectInfo?.startDate || '';
  const year = startDate ? moment(startDate).format('YYYY') : '';

  // New structure: consolidatedReports[]
  if (Array.isArray(apiResponse.consolidatedReports)) {
    const items = apiResponse.consolidatedReports.map((report) => {
      const healthScreenings = report?.healthScreenings || null;
      return {
        businessUnit: report?.customFieldQuestion || report?.groupValue || '',
        groupValue: report?.groupValue || '',
        year,
        healthScreenings,
        chartData: buildChartDataFromHealthScreenings(healthScreenings),
        tableData: healthScreenings ? { healthScreenings } : null,
      };
    });
    return { projectInfo, items };
  }

  // Back-compat: items[]
  const items = Array.isArray(apiResponse.items)
    ? apiResponse.items
    : apiResponse.items
    ? [apiResponse.items]
    : [];
  return { projectInfo, items };
}
